import Redirect from 'client/js/util/hard_redirect';
import {Link} from 'react-router-dom';
import {useState} from 'react';
import {GenericReactForm, SubmitButton, FormActions} from 'client/js/util/form_utils';
import DomainPrefixInput from "client/js/util/inputs/domain_prefix_input";
import WebsiteContentSection from './website_content_section';
import {PageHeader} from 'client/js/util/layout_utils';
import {useResource} from 'client/js/util/rest_utils';
import Callout from 'client/js/util/callout';

const Page = () => {
  const { data, component } = useResource(['websites_subdomain_new'], '/usercp/websites/subdomain/new', {
    keepPreviousData: true,
  });

  const [newRecord, setNewRecord] = useState(false);
  const [redirect_to_installer, setRedirectToInstaller] = useState(false);

  const dispatch = (action, original_event, data) => {
    if(action == 'form:success')
      setNewRecord(data.object);

    if(action == 'form:change' && data.changedField == 'content_strategy')
      setRedirectToInstaller(data.formData['content_strategy'] == 'install');
  }

  if(component)
    return component;

  if(data.domains && data.domains.length == 0)
    return (
      <>
        <PageHeader text="Subdomain erstellen" back_url="/websites" />

        <Callout title="Keine Domains vorhanden">
          <p>Derzeit sind auf Deinem Account keine Domains vorhanden.</p>

          <p>Du kannst eine Domain registrieren oder zu uns umziehen oder <Link to="/websites/lima-subdomain/new">eine kostenlose Subdomain erstellen</Link>.</p>
        </Callout>
      </>
    );

  if(newRecord)
    return <Redirect to={redirect_to_installer ? '/softwares' : '/websites'} />;

  const query = parse_query_string(location.search);

  let default_domain = null;
  if(data.domains && data.domains.length)
    default_domain = data.domains[0][0];

    if(query['usercp_create_subdomain_form[domain]'])
      default_domain = query['usercp_create_subdomain_form[domain]'];

  return (
    <>
      <PageHeader text="Subdomain erstellen" back_url="/websites" />

      <GenericReactForm namespace="usercp_create_subdomain_form"
                        defaults={{content_strategy: "same_path", domain: default_domain}}
                        url="/usercp/websites/subdomain"
                        dispatch={dispatch}>
        <DomainPrefixInput prefix_name="subdomain" hint="Als Wildcard kann bei der Subdomain der Stern (*) verwendet werden" domains={data.domains} />

        <WebsiteContentSection name="name" label="Webseiten-Inhalt" installerRedirect required />

        <FormActions>
          <SubmitButton icon="plus" text="Subdomain erstellen" />
        </FormActions>
      </GenericReactForm>
    </>
  );
}

export default Page;
